import { sessionManager } from 'vue-infra';
import { appCode } from '../../config';
import { __showAccountInformation, __showAcFeatures, __showSiteSettings } from '../../config/resources';

// use this approach to split the code of a component, and bundle it as a separate chunk that is loaded lazily
const ComingSoon = () => import('@/views/ComingSoon');
const Home = () => import('@/views/Home');
const Search = () => import('@/views/Search');
const Feature = () => import('@/views/Feature');
const Sitesetting = () => import('@/views/Sitesetting');
const AccountInformation = () => import('@/views/AccountInformation');
const AcFeatures = () => import('@/views/AcFeatures');
const AcSiteSettings = () => import('@/views/AcSiteSettings');

export default [
  {
    path: `/${appCode}/`,
    redirect: `/${appCode}/home`,
  },
  {
    path: `/${appCode}/home`,
    name: `${appCode}:home`,
    components: { [appCode]: Home },
  },
  {
    path: `/${appCode}/search`,
    name: `${appCode}:search`,
    components: { [appCode]: Search },
  },
  {
    path: `/${appCode}/feature/:uid`,
    name: `${appCode}:feature`,
    components: { [appCode]: Feature },
  },
  {
    path: `/${appCode}/sitesetting/:uid`,
    name: `${appCode}:sitesetting`,
    components: { [appCode]: Sitesetting },
  },
  {
    path: `/${appCode}/account-information`,
    name: `${appCode}:account-information`,
    components: { [appCode]: AccountInformation },
    beforeEnter(to, from, next) {
      if (__showAccountInformation) {
        next();
      } else {
        next({ name: from.name });
      }
    },
  },
  {
    path: `/${appCode}/ac-features`,
    name: `${appCode}:ac-features`,
    components: { [appCode]: AcFeatures },
    beforeEnter(to, from, next) {
      if (__showAcFeatures && sessionManager.isLPA()) {
        next();
      } else {
        next({ name: from.name });
      }
    },
  },
  {
    path: `/${appCode}/site-settings`,
    name: `${appCode}:site-settings`,
    components: { [appCode]: AcSiteSettings },
    beforeEnter(to, from, next) {
      if (__showSiteSettings && sessionManager.isLPA()) {
        next();
      } else {
        next({ name: from.name });
      }
    },
  },
  {
    path: `/${appCode}/explore`,
    name: `${appCode}:explore`,
    components: { [appCode]: ComingSoon },
  },
  {
    path: `/${appCode}/:pathMatch(.*)`,
    redirect: `/${appCode}/home`,
  },
];
